/**
 * PDFTable Component
 * Reusable table component for PDF documents
 * Design: Clean, minimal with focus on readability
 */

import React from 'react';
import { View, Text } from '@react-pdf/renderer';
import { useTranslation } from 'react-i18next';
import { styles } from '../styles';

interface PDFTableProps {
  children: React.ReactNode;
}

interface PDFTableRowProps {
  label: string;
  value: string | number | boolean | null | undefined;
  isEven?: boolean;
  formatBoolean?: boolean;
  isLast?: boolean;
}

export const PDFTable: React.FC<PDFTableProps> = ({ children }) => (
  <View style={styles.table}>{children}</View>
);

export const PDFTableRow: React.FC<PDFTableRowProps> = ({
  label,
  value,
  isEven = true,
  formatBoolean = false,
  isLast = false,
}) => {
  const { t } = useTranslation('common');
  let displayValue: string;
  let isActive = false;

  if (formatBoolean && typeof value === 'boolean') {
    displayValue = value ? t('common.yes') : t('common.no');
    isActive = value;
  } else if (value === null || value === undefined) {
    displayValue = '-';
  } else {
    displayValue = String(value);
  }

  return (
    <View
      style={[
        styles.tableRow,
        isEven ? styles.tableRowEven : styles.tableRowOdd,
        isLast ? styles.tableRowLast : {},
      ]}
    >
      <View style={styles.tableColHeader}>
        <Text style={styles.tableCellHeader}>{label}</Text>
      </View>
      <View style={styles.tableCol}>
        <Text
          style={[
            styles.tableCell,
            formatBoolean && isActive ? styles.statusActive : {},
            formatBoolean && !isActive && value === false ? styles.statusInactive : {},
          ]}
        >
          {displayValue}
        </Text>
      </View>
    </View>
  );
};
